module.exports = __webpack_public_path__ + "static/media/maintenance report.5620fc28.svg";